export const DEVICE_SETTINGS_DEVICE_SETTINGS_CHANGE_LOADER = 'DEVICE_SETTINGS_DEVICE_SETTINGS_CHANGE_LOADER';
